import { BracketemDetails } from "./Bracketem/Details";
import { RankemDetails } from "./Rankem/Details";
import { MatchemDetails } from "./Matchem/Details";
import { daysToMs } from "TimeHelper";
import {
  getPointsPartitionsPointsText,
  PointsPartition,
} from "./PointsPartition";
import { Pick } from "model/Pickem/Pickem";

export const PICKEM_OPEN_THRESHOLD_MS = daysToMs(7);

export type PickemDetailsBase = {
  closeTimeMsOverride: number | undefined;
  driverPointsRules: PointsPartition[] | undefined;
  earliestMatchTimeMs: number | undefined;
  frozenRosters: { [id: string]: Pick } | undefined;
  groupId: string | undefined;
  ignoreDrivers: string[] | undefined;
  ignoreMatchIds: string[] | undefined;
  latestMatchTimeMs: number | undefined;
  leaderboardHeader: string;
  matchIds: string[] | undefined;
  message: string | undefined;
  name: string;
  numDriverPicks: number;
  openTimeMsOverride: number | undefined;
  pickemId: string;
  pickemType: PickemType;
  resultsMessage: string | undefined;
  segmentId: string;
  tournamentId: string;
};

export type PickemType = "Bracketem" | "Matchem" | "Rankem";
export const isPickemType = (value: string): value is PickemType => {
  return ["Bracketem", "Matchem", "Rankem"].includes(value);
};

export type PickemDetails = BracketemDetails | MatchemDetails | RankemDetails;

export const getDriverPointsRulesText = (partitions: PointsPartition[]) => {
  return `Points awarded: ${getPointsPartitionsPointsText(partitions)}`;
};

export const getDriverPicksFirstLine = (numDriverPicks: number) => {
  if (numDriverPicks === 0) {
    return undefined;
  }

  if (numDriverPicks === 1) {
    return "Predict the best performing driver.";
  }

  return `Predict the ${numDriverPicks} best performing drivers.`;
};
